import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useEffect, useState, useCallback } from "react";
import Login from "./Components/Feature/Login/Login";
import Wrapper from "./Components/Common/Wrapper/Wrapper";
import { onAppInit } from "./init";
import { jwtDecode } from "jwt-decode";
import Unauthenticated from "./Components/Feature/Unauthenticated/Unauthenticated";
import { useDispatch } from "react-redux";
import { GetUserDetailByUPN } from "./Reducers/dcoi";
import { userDetails } from "./Services/api";

const Authenticated = ({ msalInstance }) => {
  const dispatch = useDispatch();
  const [isLoggedIn, setLoggedIn] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionTimeout, setSessionTimeout] = useState(null);

  const handleSessionTimeout = useCallback(() => {
    setLoggedIn("notlogged");
    window.token = null;
    window.loggedInUserId = null;
    window.role = null;
    window.name = null;
    window.upn = null;
    msalInstance.logoutRedirect();
  }, [msalInstance]);

  const onInit = useCallback(
    async (context) => {
      try {
        const token = await onAppInit(context);
        const value = await userDetails({},token);
        setLoggedIn("logged");
        setLoading(false);
        const { LoggedInUserID, Roles, unique_name, upn, exp } = jwtDecode(token);
        window.loggedInUserId = LoggedInUserID;
        window.token = token;
        window.role = parseInt(Roles, 10);
        window.name = unique_name;
        window.upn = upn;
        window.IsVendor = value?.data[0]?.IsVendor === 1 ? true : false;
        window.IsDcoi = value?.data[0]?.IsDCOI === 1 ? true : false;
        const currentTime = Math.floor(Date.now() / 1000);
        const timeToExpire = exp - currentTime;

        if (timeToExpire > 0) {
          const timeoutId = setTimeout(handleSessionTimeout, timeToExpire * 1000);
          setSessionTimeout(timeoutId);
        } else {
          handleSessionTimeout();
        }
      } catch (err) {
        console.error("Error during initialization:", err);
        setLoggedIn("notlogged");
        setLoading(false);
      }
    },
    [handleSessionTimeout]
  );

  useEffect(() => {
    const account = msalInstance.getActiveAccount();
    if (account?.username) {
      if (!window.token) {
        onInit(account);
      } else {
        setLoggedIn("logged");
        setLoading(false);
      }
    } else {
      setLoggedIn("notlogged");
      setLoading(false);
    }

    return () => {
      if (sessionTimeout) clearTimeout(sessionTimeout);
    };
  }, [msalInstance, onInit, sessionTimeout]);

  if (loading) return <>Loading...</>;

  return isLoggedIn === "logged" ? <Wrapper /> : <Unauthenticated />;
};

const App = ({ msalInstance }) => (
  <MsalProvider instance={msalInstance}>
    <AuthenticatedTemplate>
      <Authenticated msalInstance={msalInstance} />
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <Login />
    </UnauthenticatedTemplate>
  </MsalProvider>
);

export default App;